﻿module.exports = {
    CARD: 'card',
    PAYPAL: 'paypal'
};